import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IMobizHttpService, SerializableObjectList } from '../../common-react/core';
import { Inject, Injectable, InjectionToken } from '../../common-react/injection';

import { ShipmentDeliveryService } from '../data/shipment-delivery-service.do';
import { PosturinnApiEndpointConfiguration } from '../other/api-endpoint-configuration.interface';
import { PosturinnServerApi } from '../other/posturinn-server-api.enum';

export interface IShipmentDeliveryServicesBracketsQueryParams {
  'postal-code-from'?: string;
  'postal-code-to'?: string;
  'weight'?: string;
}

export interface IShipmentDeliveryServicesQueryParams {
  'senderPostalCode': string;
  'recipientPostalCode': string;
  'recipientCountryCode': string;
  'type'?: string;
  'weight'?: string;
  'weightUnit'?: string;
  'length'?: string;
  'height'?: string;
  'width'?: string;
  'dimensionUnit'?: string;
}

export interface IDeliveryServicesService {
  getShipmentDeliveryServices(queryParams?: IShipmentDeliveryServicesQueryParams): Observable<ShipmentDeliveryService[]>;
  getShipmentDeliveryServiceBrackets(queryParams?: IShipmentDeliveryServicesBracketsQueryParams): Observable<ShipmentDeliveryService[]>;
}

export const IDeliveryServicesService
  = new InjectionToken<IDeliveryServicesService>('IDeliveryServicesService');

@Injectable()
export class DeliveryServicesService implements IDeliveryServicesService {

  constructor(
    @Inject(IMobizHttpService)
    private httpService: IMobizHttpService,
  ) {
  }

  public getShipmentDeliveryServiceBrackets(queryParams?:
    IShipmentDeliveryServicesBracketsQueryParams): Observable<ShipmentDeliveryService[]> {
    const config: PosturinnApiEndpointConfiguration = {
      serverApi: PosturinnServerApi.DeliveryServiceBrackets,
      queryParameters: {
        ...queryParams,
      },
    };
    const list: SerializableObjectList<ShipmentDeliveryService> = new SerializableObjectList(ShipmentDeliveryService);
    return this.httpService.get(list, config).pipe(
      map((response: SerializableObjectList<ShipmentDeliveryService>): ShipmentDeliveryService[] => {
        return response.items ? response.items : [];
      }),
    );
  }

  public getShipmentDeliveryServices(queryParams?: IShipmentDeliveryServicesQueryParams): Observable<ShipmentDeliveryService[]> {
    const config: PosturinnApiEndpointConfiguration = {
      serverApi: PosturinnServerApi.DeliveryServices,
      queryParameters: {
        ...queryParams,
      },
    };
    const list: SerializableObjectList<ShipmentDeliveryService> = new SerializableObjectList(ShipmentDeliveryService);
    return this.httpService.get(list, config).pipe(
      map((response: SerializableObjectList<ShipmentDeliveryService>): ShipmentDeliveryService[] => {
        return response.items ? response.items : [];
      }),
    );
  }

}
